module.exports = __webpack_public_path__ + "img/e_2_15_r.cf74149f.png";